import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import Breadcrumb from 'components/ui/Breadcrumb';
import LoginForm from './components/LoginForm';
import RegisterForm from './components/RegisterForm';
import SocialAuth from './components/SocialAuth';

const JobSeekerRegistrationLogin = () => {
  const [activeTab, setActiveTab] = useState('login');
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const navigate = useNavigate();

  const breadcrumbItems = [
    { label: 'Home', path: '/job-search-browse' },
    { label: 'Sign In', path: '/job-seeker-registration-login', isLast: true }
  ];

  const handleAuthSuccess = (userData) => {
    if (userData?.isRegistration) {
      setShowConfirmation(true);
      window.scrollTo(0, 0);
      return;
    }

    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      console.log('Authentication successful:', userData);
      navigate('/job-seeker-dashboard');
    }, 1500);
  };

  const handleTabSwitch = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="min-h-screen bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Breadcrumb customItems={breadcrumbItems} />

        <div className="max-w-md mx-auto">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="flex justify-center mb-4">
              <img
                src="/assets/images/Copy_of_Add_a_subheading_3_-removebg-preview-1766240030553.png"
                alt="GradOne logo"
                className="h-16 w-auto object-contain"
              />
            </div>
            <h1 className="text-3xl font-bold text-text-primary mb-2">
              Welcome to GradOne
            </h1>
            <p className="text-text-secondary">
              {activeTab === 'login' ? 'Sign in to access your personalized job dashboard' : 'Create your account to start your job search journey'
              }
            </p>
          </div>

          {/* Tab Navigation */}
          {!showConfirmation && (
            <div className="bg-background rounded-lg p-1 mb-6 border border-border">
              <div className="grid grid-cols-2 gap-1">
                <button
                  onClick={() => handleTabSwitch('login')}
                  className={`py-3 px-4 rounded-md text-sm font-medium transition-smooth ${activeTab === 'login' ? 'bg-primary text-primary-foreground shadow-sm' : 'text-text-secondary hover:text-text-primary'
                    }`}
                >
                  Sign In
                </button>
                <button
                  onClick={() => handleTabSwitch('register')}
                  className={`py-3 px-4 rounded-md text-sm font-medium transition-smooth ${activeTab === 'register' ? 'bg-primary text-primary-foreground shadow-sm' : 'text-text-secondary hover:text-text-primary'
                    }`}
                >
                  Create Account
                </button>
              </div>
            </div>
          )}

          {/* Form Container */}
          <div className="bg-background rounded-lg shadow-soft border border-border p-6 mb-6">
            {showConfirmation ? (
              <div className="text-center py-8">
                <div className="w-16 h-16 bg-success-50 rounded-full flex items-center justify-center mx-auto mb-4">
                  <img src="/assets/icons/mail.svg" alt="Email" className="w-8 h-8" onError={(e) => { e.target.style.display = 'none'; }} />
                </div>
                <h2 className="text-2xl font-bold text-text-primary mb-4">Check your email</h2>
                <p className="text-text-secondary mb-8">
                  We've sent a link to your email address. <strong>please confirm your signup from email</strong> to activate your account.
                </p>
                <button
                  onClick={() => setShowConfirmation(false)}
                  className="btn-primary w-full"
                >
                  Return to Sign In
                </button>
              </div>
            ) : (
              <>
                {/* Social Authentication */}
                <SocialAuth onSuccess={handleAuthSuccess} isLoading={isLoading} />

                {/* Divider */}
                <div className="relative my-6">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-border"></div>
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span className="px-2 bg-background text-text-secondary">Or continue with email</span>
                  </div>
                </div>

                {/* Forms */}
                {activeTab === 'login' ? (
                  <LoginForm onSuccess={handleAuthSuccess} isLoading={isLoading} />
                ) : (
                  <RegisterForm onSuccess={handleAuthSuccess} isLoading={isLoading} />
                )}
              </>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default JobSeekerRegistrationLogin;